// extracted by mini-css-extract-plugin
export default {"formTitle":"PersonalDetails_formTitle__ITcWO"};